import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function LanguageSwitcher({ onToggle }) {
    const [isTamil, setIsTamil] = useState(false);

    const handleToggle = () => {
        setIsTamil(!isTamil);
        if (onToggle) onToggle(isTamil ? "en" : "ta"); // Pass the selected language
    };

    useEffect(() => {
        localStorage.getItem('i18nextLng') === 'ta' ? setIsTamil(true) : setIsTamil(false);
    }, [])

    return (
        <motion.div
            className="w-auto flex flex-row justify-center items-center cursor-pointer font-bold space-x-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <span className={`${isTamil ? "text-gray-400" : "text-blue-600"}`}>
                English
            </span>

            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isTamil}
                    onChange={handleToggle}
                />
                <div className="w-11 h-6 bg-gray-300 peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-1 after:left-1 after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
            </label>

            <span className={`${isTamil ? "text-blue-600" : "text-gray-400"}`}>
                தமிழ்
            </span>
        </motion.div>
    );
}